module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="container-fluid">\n  <div class="row">\n    <div class="col-md-6">\n      <h1>This page does not exist</h1>\n      <p><strong>Error code 404</strong></p>\n      <p>We cannot find the page you were looking for. Try something else.</p>\n    </div>\n  </div>\n</div>\n';

}
return __p
}